module.exports = __webpack_public_path__ + "media/images/flags/64/Iraq-bddd4b7d328a021aed8dbc808efc8e4b.png";